import React from 'react';

import Divider from '../../../../Divider/Divider';
import InlineSection from '../../../../InlineSection';

const AdditionalInfo = ({ text, icon }) => ({ theme }) => (
    <>
        <Divider theme={ theme } />
        <InlineSection
            theme={ theme }
            mainContent={ text }
            subContent={ icon || null }
        />
        <Divider theme={ theme } />
    </>
);

export default AdditionalInfo;
